import debounce from 'lodash/debounce';
import { useEffect, useMemo, useRef } from 'react';

type Callback = () => void;
type DebouncedCallback = ReturnType<typeof debounce<any>>;

// Callback can be updated by state, but this will still debounce it even if its dependencies
// are updated between multiple calls
const useDebouncedCallback = (callback: Callback, delayMs: number = 1000): DebouncedCallback => {
  const ref = useRef<Callback>();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, delayMs);
  }, [delayMs]);

  return debouncedCallback;
};

export default useDebouncedCallback;
